export default __webpack_public_path__ + "static/media/file.aeb891c1.svg";